import React, { useCallback } from 'react';
import Template from './template';
import { ServiceInterviewAnswer } from 'components';
import { useServiceStatus } from 'hooks';
import { APP_GUIDE } from 'router/PageUrl';

function ServiceInterviewAnswerView(): React.ReactElement {
  const { serviceType, serviceState } = useServiceStatus();
  const { interviewDate } = serviceState;

  const onClickCallback = useCallback(() => {
    window.open(`${APP_GUIDE.url}/${serviceType}`);
  }, [serviceType]);

  return (
    <Template>
      <ServiceInterviewAnswer
        serviceType={serviceType}
        interviewDate={interviewDate}
        onClick={onClickCallback}
      />
    </Template>
  );
}

export default ServiceInterviewAnswerView;
